//-------------------------
// create adj detail entry
//-------------------------
export default function createAdjDetailEntry({
  id = null,
  name = '',
  adj_reason = '',
  adj_value = 0,
  // character_item holds the linked CharacterItem (or its id), not the static Item
  character_item = null,
  editable = true,
  rune = '',
  source = '', // e.g. 'characteristic', 'integrated_rune'
  applied = false, // default to optional adjustment (only used for skill adjs)
  persistable = false,
} = {}) {
  return {
    id,
    name,
    adj_reason,
    adj_value,
    character_item,
    editable,
    rune,
    source,
    applied,
    persistable,
  }
}
